import { PdfExportColumns } from "./PdfExportColumns"

import {
    dotAndClip,
    foldMeIcon,
  } from "../../assets/encoded-bg-img";

export const PdfExportTable = (pdf, startY, pdfWidth, summaryUnitLabels, waypointData) => {
    const smallColsWidth = 140;

    pdf.autoTable(PdfExportColumns(summaryUnitLabels), waypointData, {
        didDrawPage: function () {
            pdf.addImage(
              foldMeIcon,
              "PNG",
              pdfWidth / 2,
              pdf.internal.pageSize.getHeight() / 2 - 10,
              20,
              20,
              undefined,
              "FAST"
            );
            pdf.addImage(
              dotAndClip,
              "PNG",
              pdfWidth - 22,
              5,
              20,
              20,
              undefined,
              "FAST"
            );
            pdf.addImage(
              dotAndClip,
              "PNG",
              pdfWidth - 22,
              pdf.internal.pageSize.getHeight() - 25,
              20,
              20,
              undefined,
              "FAST"
            );
            pdf.setFontSize(10);
            pdf.setTextColor("#ffffff");
            for (let i = 0; i < pdfWidth; i++) {
              if (i % 15 === 0 && i > 0) {
                pdf.text("_", i, pdf.internal.pageSize.getHeight() / 2 - 1);
              }
            }
          },
          startY: startY, // pdf.internal.pageSize.getHeight() / 2 + 20
          margin: { horizontal: 10 },
          styles: { overflow: "linebreak" },
          bodyStyles: { valign: "top" },
          // columnStyles: { email: { cellWidth: "wrap" } },
          theme: "striped",
        });
      };  